document.addEventListener("DOMContentLoaded", () => {
    const headings = document.querySelectorAll(".title-text__title");
  
    headings.forEach((heading) => {
      const spans = heading.querySelectorAll("p:not(:last-child) span");
  
      spans.forEach((span) => {
        const wrapper = document.createElement("div");
        wrapper.classList.add("title-text__char-wrapper");
        wrapper.style.position = "relative";
        span.style.position = "absolute";
  
        span.parentNode.insertBefore(wrapper, span);
        wrapper.appendChild(span);
      });
    });
  
    function updateWrapperSizes() {
      const wrappers = document.querySelectorAll(".title-text__char-wrapper");
  
      wrappers.forEach((wrapper) => {
        const span = wrapper.querySelector("span");
        const rect = span.getBoundingClientRect();
        wrapper.style.width = `${rect.width}px`;
        wrapper.style.height = `${rect.height}px`;
      });
    }
  
    // Prvo pozivamo odmah
    requestAnimationFrame(updateWrapperSizes);
  
    // Ažuriraj na resize prozora
    window.addEventListener("resize", () => {
      requestAnimationFrame(updateWrapperSizes);
    });
  
    // BONUS: ako koristiš promene font-size sa klasama ili animacijama, možeš dodati MutationObserver
    const observer = new ResizeObserver(updateWrapperSizes);
    document.querySelectorAll(".title-text__title").forEach((el) => {
      observer.observe(el);
    });
  });
  